import { FC } from "react";
import { Control } from "react-hook-form";

import StyledSwitch from "@/components/forms/StyledSwitch";
import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface UnderMaintenanceFieldProps {
  control: Control<CryptorFormData, {}>;
}

const UnderMaintenanceField: FC<UnderMaintenanceFieldProps> = ({ control }) => {
  return (
    <StyledSwitch
      control={control}
      name="underMaintenance"
      label="Maintenance en cours"
    />
  );
};

export default UnderMaintenanceField;
